module.exports = __webpack_public_path__ + "img/Logo_Virtual_Partner.bf688e86.svg";